import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

const convertToHierarchy = (data) => {
  const output = {};

  data.forEach(row => {
    if (row.type === "main") {
      if (!output[row.label]) output[row.label] = {};
    }

    if (row.type === "group") {
      if (!output[row.mainKey]) output[row.mainKey] = {};
      if (!output[row.mainKey][row.label]) {
        output[row.mainKey][row.label] = [];
      }

      output[row.mainKey][row.label].push({
        isGroupHeader: true,
        grp_desc: row.label,
        order_pl: row.order_pl,
        order_bl: row.order_bl,
        schedule: row.schedule
      });
    }

    if (row.type === "sub") {
      const groupParts = row.groupKey.split("-");
      const main = groupParts[0];
      const group = groupParts[1];

      output[main][group].push({
        sub_grp_desc: row.label,
        order_pl: row.order_pl,
        order_bl: row.order_bl,
        schedule: ""
      });
    }
  });

  return output;
};


export const exportCGExcel = ({ groupedData, societyName }) => {

  const wb = XLSX.utils.book_new();
  const wsData = [];

  // Convert flat array → hierarchical object
  const structuredData = convertToHierarchy(groupedData);

  // -------------------------------------------------
  // 1. Report top header
  // -------------------------------------------------

  wsData.push([`${societyName}`]);
  wsData.push([]);
  wsData.push([`Chart Of Groups`]);
  wsData.push([]);

  // -------------------------------------------------
  // 2. COLUMN HEADER (the missing one!)
  // -------------------------------------------------

  wsData.push([
    "Description",
    "Order PL",
    "Order BL",
    "Schedule"
  ]);

  // -------------------------------------------------
  // 3. Build hierarchical rows
  // -------------------------------------------------

  Object.keys(structuredData).forEach(mainGrp => {

    // Main Group
    wsData.push([mainGrp]);

    const groups = structuredData[mainGrp];

    Object.keys(groups).forEach(grp => {
      const rows = groups[grp];

      const groupHeader = rows.find(r => r.isGroupHeader);

      wsData.push([
        `   ➤ ${grp}`,
        groupHeader.order_pl || "",
        groupHeader.order_bl || "",
        groupHeader.schedule || ""
      ]);

      // Subgroups
      rows.forEach(sub => {
        if (sub.isGroupHeader) return;
        wsData.push([
          `        - ${sub.sub_grp_desc}`,
          sub.order_pl || "",
          sub.order_bl || "",
          ""
        ]);
      });

      wsData.push([]); // spacing
    });

    wsData.push([]); // spacing
  });

  // -------------------------------------------------
  // 4. Create sheet
  // -------------------------------------------------

  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const range = XLSX.utils.decode_range(ws["!ref"]);
  if (!ws["!merges"]) ws["!merges"] = [];

  // -------------------------------------------------
  // 5. Formatting updates
  // -------------------------------------------------

  for (let R = range.s.r; R <= range.e.r; ++R) {
    const row = wsData[R];

    for (let C = 0; C < 4; C++) {

      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellRef];
      if (!cell) continue;

      // BIG REPORT HEADERS
      if (R === 0 || R === 2) {
        cell.s = {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" }
        };
        ws["!merges"].push({ s: { r: R, c: 0 }, e: { r: R, c: 3 } });
        continue;
      }

      // ⭐ COLUMN HEADER (the new header)
      if (R === 4) {
        cell.s = {
          font: { bold: true },
          alignment: { horizontal: "center" },
          fill: { fgColor: { rgb: "DDDDDD" } }
        };
        continue;
      }

      // Main Group rows
      if (row.length === 1 && R > 4) {
        cell.s = {
          font: { bold: true, sz: 12 },
          fill: { fgColor: { rgb: "CFE0FF" } }
        };
        ws["!merges"].push({ s: { r: R, c: 0 }, e: { r: R, c: 3 } });
        continue;
      }

      // Group Row
      if (typeof row[0] === "string" && row[0].trim().startsWith("➤")) {
        cell.s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "E7F0FF" } },
          alignment: { horizontal: C === 0 ? "left" : "right" }
        };
        continue;
      }

      // Sub Rows
      if (typeof row[0] === "string" && row[0].includes(" - ")) {
        cell.s = {
          alignment: { horizontal: C === 0 ? "left" : "right" }
        };
        continue;
      }
    }
  }

  // Column widths
  ws["!cols"] = [
    { wch: 50 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 }
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Chart_Groups");

  const wbout = XLSX.write(wb, { type: "array", bookType: "xlsx" });

  saveAs(
    new Blob([wbout], { type: "application/octet-stream" }),
    `Chart_Group_Report.xlsx`
  );
};
